import WaterSupplyIcon from './component'

export default WaterSupplyIcon
